<template>
  <div class="page_content">

  	<div class="page_heading">
  		<div class="col-5 module_heading" role="heading" aria-level="1">
  		  <span class="module_icon icon-channel"></span>
  		  <span class="module_type_name">Channel Management</span>
  		</div>

  		<div class="col-7 btn_container">
  		  <b-button :to="{ name: 'createChannel' }" aria-label="create">create</b-button>
        <b-button :disabled="(selected.length === 0)" @click.prevent="showDeleteConfirm" aria-label="delete">delete</b-button>
  		</div>
    </div>

  	<div class="course-management-section">
      <div class="page_subheading">
        <div class="course-list-left">
          <span class="selected-count ace_sec_txt">selected: {{ selected.length }} of {{ totalElements }}</span>
        </div>
        <div class="toolbar-right ui-list-toolbar">
          <select v-model="pageSize" @change="resetPage" aria-label="page size" class="page_size">
            <option v-for="option in sizeOptions" v-bind:value="option">
              {{ option }}
            </option>
          </select>
          <div class="btn_container pagination_sty3">
            <button type="button" :disabled="firstPage" v-on:click="prev" class="btn btn_trans" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
            <span class="page_count" aria-hidden="true">{{ page + 1 }}</span>
            <button type="button" :disabled="lastPage" v-on:click="next" class="btn btn_trans" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
          </div>
        </div>
      </div>
      <div class="course-management-table-container">
    		<table v-if="isChannelsLoaded" class="table b-table table-bordered border">
    			<thead class="thead-light text-center">
    				<tr>
              <th class="first-column">
                <label class="form-checkbox">
                  <input type="checkbox" v-model="selectAll" @click="select" :disabled="(channelList.length === 0) || permission.systemPermission.readOnly" aria-label="select all channels">
                  <i class="form-icon"></i>
                </label>
              </th>
    					<th class="second-column">Title</th>
    				</tr>
    			</thead>
    			<tbody v-if="channelList.length > 0">
            <tr v-for="channel in channelList">
              <td class="first-column text-center">
                <label class="form-checkbox">
                  <input type="checkbox" :value="channel.uuid" v-model="selected" :disabled="(channelList.length === 0) || permission.systemPermission.readOnly" aria-label="select channel">
                  <i class="form-icon"></i>
                </label>
              </td>
              <td class="second-column">
                <a href="javascript://" @click="goToChannelDetail(channel.uuid)">{{channel.channelName}}</a>
              </td>
            </tr>
    			</tbody>
          <tbody v-else>
            <tr>
              <td colspan="5" class="no-result" style="text-align: center;">No Results Found</td>
            </tr>
          </tbody>
    		</table>
      </div>
  	</div>

    <div>
      <b-modal class="delete-folder-popup" ref="deleteConfirmModal" no-close-on-backdrop no-close-on-esc centered>
        <div style="text-align: center;">
          <h6>Are you sure you want delete these ({{ selected.length }}) Channels?</h6>
        </div>
        <div slot="modal-header" class="header-section" style="padding: 10px 9px 6px 12px;">
          <div class="popup-heading">Please Confirm!</div>
          <button class="btn_close" aria-label="close" @click="cancelDelete">
            <span class="ic-close"></span>
          </button>
        </div>
        <div slot="modal-footer" class="w-100">
          <b-button @click="deleteSelected" class="btn button-primary next float-right mr-2" aria-label="ok"> yes </b-button>
          <b-button @click="cancelDelete" class="btn button-primary next float-right mr-2" aria-label="cancel"> no </b-button>
        </div>
      </b-modal>
    </div>

    <div class="loading-spinner">
      <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
        <div class="text-center" style="color: #FFF">
          <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
        </div>
      </b-modal>
    </div>

  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import '../../../assets/module/sass/channel/channel.scss'
  export default {
    name: 'listChannels',
    data: () => {
      return {
        channelList: [],
        pageSize: 10,
        sizeOptions: [ 10, 50, 100 ],
        firstPage: true,
        lastPage: false,
        page: 0,
        totalElements: 0,
        selected: [],
        selectAll: false,
        isChannelsLoaded: false
      }
    },
    mounted () {
      this.showLoader()
      setTimeout(() => {
        this.loadChannels()
      }, 500)
    },
    methods: {
      ...mapActions([
        'loadAllChannels',
        'loadPaginatedChannels',
        'loadDeleteChannels'
      ]),
      showLoader () {
        this.$refs.loadingModal.show()
      },
      hideLoader () {
        this.$refs.loadingModal.hide()
      },
      goToChannelDetail (uuid) {
        return this.$router.push({name: 'channelDetail', params: { uuid: uuid }})
      },
      async loadChannels (isDeleted) {
        this.loadPaginatedChannels({page: this.page, count: this.pageSize}).then(result => {
          if (result) {
            this.channelList = result.content
            this.firstPage = result.first
            this.lastPage = result.last
            this.page = result.number
            this.totalElements = result.totalElements
          }
          this.hideLoader()
          this.isChannelsLoaded = true
          this.selected = []
          this.selectAll = false
        })
        if (isDeleted) {
          this.$store.commit('LOAD_ALL_CHANNELS', [])
          await this.loadAllChannels()
        }
      },
      resetPage () {
        this.page = 0
        this.loadChannels(false)
      },
      prev () {
        this.page -= 1
        this.loadChannels(false)
      },
      next () {
        this.page += 1
        this.loadChannels(false)
      },
      select () {
        this.selected = []
        if (!this.selectAll) {
          for (var i in this.channelList) {
            this.selected.push(this.channelList[i].uuid)
          }
        }
      },
      showDeleteConfirm () {
        if (this.selected.length > 0) {
          this.$refs.deleteConfirmModal.show()
        }
      },
      deleteSelected () {
        this.$refs.deleteConfirmModal.hide()
        this.$refs.loadingModal.show()
        this.loadDeleteChannels(this.selected).then(res => {
          if (res) {
            if (res.succeeded > 0) {
              let message = '' + res.succeeded + ' Channel(s) deleted successfully.'
              setTimeout(() => {
                this.$notify({
                  group: 'notify',
                  type: 'success',
                  title: '',
                  text: message
                })
              }, 0)
            }
            if (res.unauthorized > 0) {
              let message = '' + res.unauthorized + ' Channel(s) not deleted due to lack of permission.'
              setTimeout(() => {
                this.$notify({
                  group: 'notify',
                  type: 'warn',
                  title: '',
                  text: message
                })
              }, 500)
            }
          } else {
            this.$notify({
              group: 'notify',
              type: 'error',
              title: '',
              text: 'Channel deletion failed due to a network issue.'
            })
          }
          setTimeout(() => {
            this.loadChannels(true)
          }, 1000)
        })
        this.selected = []
        this.selectAll = false
      },
      cancelDelete () {
        this.$refs.deleteConfirmModal.hide()
        this.selected = []
        this.selectAll = false
      }
    },
    computed: {
      ...mapState({
        'permission': state => state.user.permission
      }),
      currentInstitutionId () {
        var userObj = JSON.parse(localStorage.getItem('userobj'))
        return userObj.institutionId
      }
    }
  }
</script>
<style>
.margin-top-10 {
  margin-top: 10px;
}
.margin-top-20 {
  margin-top: 20px;
}
.margin-top-30 {
  margin-top: 30px;
}
.no-border {
  border: none;
}
.margin-left-20 {
  margin-left: 20px;
}
td a {
  display:block;
  width:100%;
}
</style>



// WEBPACK FOOTER //
// src/app/channel/components/ListChannels.vue